<template>
  <v-container class="pa-0" fluid>
    <v-row class="mb-5">
      <v-col cols="12">
        <v-skeleton-loader type="card"> </v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
        <v-skeleton-loader type="text" class="mb-2" v-for="n in 5" :key="n">
        </v-skeleton-loader>
        <v-skeleton-loader type="card" class="my-10"> </v-skeleton-loader>
        <v-skeleton-loader type="card"> </v-skeleton-loader>
      </v-col>
      <v-col cols="9">
        <div>
          <v-row>
            <v-col lg="6" sm="12" v-for="n in 8" :key="n">
              <v-skeleton-loader type="card"> </v-skeleton-loader>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'k-fooldal-desktop-skeleton',
  data() {
    return {};
  },
  mounted() {},
  created() {},
  methods: {},
  computed: {
    ...mapGetters({}),
  },
  watch: {},
  components: {},
};
</script>
